<template>
  <div class="content-wrapper safe-top">
    <div class="form form-middle">
      <h1 class="title">処理中です</h1>
      <div class="form-content-middle">
        <div class="img-container">
          <PulseLoader color="#fdc908" />
        </div>
        <div class="msg">このままお待ちください。</div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watchEffect } from "vue";

import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "TemplateBookBookingResultProcessing",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const paymentProcessInfo = computed(
      () => store.getters["ticketing/paymentProcessInfo"]
    );

    watchEffect(() => {
      if (paymentProcessInfo.value != null) {
        gotoBookBookingReuslt();
      }
    });

    const gotoBookBookingReuslt = () => {
      router.push({
        name: "BookBookingResult",
        params: {
          id: route.params.id,
          book_group_id: store.getters["ticketing/bookGroup"].id,
        },
        query: {
          language: store.getters["common/lang"],
          is_0yen_ticket: route.query.is_0yen_ticket,
          coupon_issued: paymentProcessInfo.value.coupon_issued,
        },
      });
    };

    return {};
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin: 15px 0 22px 0 !important;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
.msg {
  margin: 15px 0 22px 0 !important;
  font-size: 18px;
  text-align: center;
}
.img-container {
  text-align: center;
}
.safe-top {
  margin-top: calc(30px + env(safe-area-inset-top, 30px) + 30px);
}
.form-middle {
  position: absolute;
  width: 100%;
  height: 50%;
}

.form-content-middle {
  position: absolute;
  width: 100%;
  bottom: 0px;
}
</style>
